export function useSearchProductHelper(): SearchProductHelper {
  const getAttributeValueByName = (product: ProductSearchContent, attributeName: string) => {
    return product.attributes.find((attr) => attr.name === attributeName)?.value ?? null;
  };

  const getAttributeValuesByExternalId = (
    product: ProductSearchContent,
    attributeExternalId: string
  ) => {
    return (
      product.attributes.find((attr) => attr.externalId === attributeExternalId)?.value ?? null
    );
  };

  const getFacets = (searchResponse: SearchProductsResponse) => {
    if (!searchResponse.facets) return;
    const facets = Object.assign(searchResponse.facets);
    const productTags = facets.productTags.filter(
      (tag: any) => tag.id !== '0000007461' && tag.id !== '0000007462'
    ); // remove unused tags (newhp and moishp)
    return Object.assign(facets, { productTags });
  };

  const getOfferCustomFieldValueByExternalId = (
    product: ProductSearchContent,
    externalId: string
  ) => {
    return (
      product.offer.customFields.find((customField) => customField.externalId === externalId)
        ?.value ?? null
    );
  };

  return {
    getAttributeValueByName,
    getAttributeValuesByExternalId,
    getFacets,
    getOfferCustomFieldValueByExternalId,
  };
}
